// components/Rankings.tsx
import React, { useState, useEffect } from "react";
import { DatabaseService } from "./services/database";

interface Ranking {
  first_name: string;
  last_name: string;
  top_category: string;
  top_score: number;
  completed_at: string;
}

interface RankingsProps {
  language: "en" | "bg";
  onClose: () => void;
}

export const Rankings: React.FC<RankingsProps> = ({ language, onClose }) => {
  const [rankings, setRankings] = useState<Ranking[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        setLoading(true);
        const data = await DatabaseService.getRankings();
        setRankings(data as Ranking[]);
      } catch (err) {
        console.error("Error fetching rankings:", err);
        setError(
          language === "en"
            ? "Failed to load rankings"
            : "Грешка при зареждане на класацията",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRankings();
  }, [language]);

  if (loading) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div className="modal show d-block" tabIndex={-1}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {language === "en" ? "Top Quiz Results" : "Топ Резултати"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>{language === "en" ? "Rank" : "Ранг"}</th>
                    <th>{language === "en" ? "Name" : "Име"}</th>
                    <th>
                      {language === "en" ? "Top Category" : "Топ Категория"}
                    </th>
                    <th>{language === "en" ? "Score" : "Резултат"}</th>
                    <th>{language === "en" ? "Date" : "Дата"}</th>
                  </tr>
                </thead>
                <tbody>
                  {rankings.map((rank, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{`${rank.first_name} ${rank.last_name}`}</td>
                      <td>{rank.top_category}</td>
                      <td>{rank.top_score}</td>
                      <td>
                        {new Date(rank.completed_at).toLocaleDateString(
                          language === "en" ? "en-US" : "bg-BG",
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {language === "en" ? "Close" : "Затвори"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
